import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@blueprintjs/core';

/**
 * @props {string} iconName
 * @props {string} title
 * @props {function} onClick - required
 * @props {Object} returnObj
 */
class IconSmallButton extends Component {
	render() {
		const { onClick, title, iconName } = this.props;
		return <Button
			className = {this.className()} 
			onClick = { onClick }
			title = { title }
		>
			<Icon 
				icon = { iconName }
				title = ''
			/>
		</Button>;
	}

	onClick = (e) => {
		const { returnObj, onClick } = this.props;
		onClick(e, returnObj);
	}

	className = () => {
		const { iconName, classNameAdd } = this.props;
		const baseClass = 'pt-button pt-small';
		return classNameAdd === '' ? baseClass: baseClass +  ' ' + classNameAdd;  
	}
}

IconSmallButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	iconName: PropTypes.string,
	classNameAdd: PropTypes.string,
	title: PropTypes.string,
	returnObj: PropTypes.object
}

IconSmallButton.defaultProps = {
	iconName: 'comment',
	classNameAdd: '',
	title: '',
	returnObj: {}
}

export default IconSmallButton;


// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/IconSmallButton.jsx